import {useDispatch, useSelector} from "react-redux";
import {getCurrentUser} from "../../../store/CommonSlice";
import {getUserSettings, modifySettings, setCity} from "../../../store/SettingsSlice";
import React, {useContext, useState} from "react";
import {UploadOutlined, UserOutlined, VideoCameraOutlined} from '@ant-design/icons';
import {Divider, Layout, List, Select, Switch, theme} from 'antd';
import {ApiContext} from "../../../ApiContext";
import axios from "axios";
import ErrorPage from "../../../routes/ErrorPage";

export const SettingsPage = () => {

    const dispatch = useDispatch();
    const currentUser = useSelector(getCurrentUser);
    const userSettings = useSelector(getUserSettings);
    // const [selectedFile, setSelectedFile] = useState(null);
    const [selectedSettingsSection, setSelectedSettingSection] = useState(0)
    const {txt, translate, genderList} = useContext(ApiContext);

    const handleCity = (city) => {
        const body = {code: 'city', value: city.uuid};
        axios.post('/api/v1/current-user/setting', body).catch(error => {
        });
        dispatch(setCity(city.uuid));
    }
    // const [openSection, setOpenSection] = useState({
    //     preferences: route?.params?.preferences || false,
    //     calendar: route?.params?.calendar || false,
    //     general: route?.params?.general || false,
    //     security: route?.params?.security || false,
    //     notifications: route?.params?.notifications || false
    // });


    const {Content, Sider} = Layout;
    const items = [UserOutlined, VideoCameraOutlined, UploadOutlined, UserOutlined].map(
        (icon, index) => ({
            key: index,
            icon: React.createElement(icon),
            label: `nav ${index + 1}`,
        }),
    );

    class SettingSection {
        icon;
        content = <ErrorPage/>;
        label;

        constructor(content, label, icon) {
            this.content = content;
            this.label = label;
            this.icon = icon === undefined ? icon : React.createElement(icon);
        }
    }

    const settingSections = [
        new SettingSection(<SettingsSectionNotifications
            userSettings={userSettings}/>, txt('clientSettingsView.notifications')),

    ]

    const {
        token: {colorBgContainer, borderRadiusLG},
    } = theme.useToken();
    return (
        <Layout>
            {/*<Sider>*/}
            {/*    <Menu*/}
            {/*        theme="dark"*/}
            {/*        mode="inline"*/}
            {/*        // defaultSelectedKeys={['4']}*/}
            {/*        // defaultOpenKeys={'1'}*/}
            {/*        // selectedKeys={'0'}*/}
            {/*        items={items}*/}
            {/*        onSelect={(item) => setSelectedSettingSection(item.key)}*/}
            {/*    />*/}
            {/*</Sider>*/}
            <Layout>
                <Content>
                    {/*settingSections.at(selectedSettingsSection)?.content || <ErrorPage/>*/}
                    {settingSections.at(0)?.content || <ErrorPage/>}
                </Content>
            </Layout>
        </Layout>
    );
};

export const SettingsSectionNotifications = ({userSettings}) => {
    const dispatch = useDispatch();
    const {txt} = useContext(ApiContext);

    // Порядок и типы пуш-уведомлений (код настройки — PUSH_<TYPE>). Отсутствие = включено.
    const PUSH_TYPES = ['IMMEDIATE', 'UPCOMING', 'EARLY', 'SYSTEM', 'INFO'];
    const pushCode = (type) => `PUSH_${type}`;

    // Варианты времени напоминания (в минутах). Значение хранится строкой, по умолчанию '90'.
    const UPCOMING_ADVANCE_OPTIONS = [30, 60, 90, 120, 180];
    const UPCOMING_ADVANCE_DEFAULT = '90';

    // Сохранить настройку пользователя через общий эндпоинт (значения — строки 'true'/'false'/минуты).
    const saveSetting = (code, value) => {
        const body = {settingType: 'user', code, value};
        axios.post('/api/v1/current-user/setting', body).catch(error => {
        });
        dispatch(modifySettings({user: {[code]: value}}));
    };

    // Настройка включена, если явно не 'false' (отсутствие значения = включено).
    const isOn = (code) => userSettings?.[code] !== 'false';
    const toggleSetting = (code) => saveSetting(code, isOn(code) ? 'false' : 'true');

    // Мастер-свитч включён, если включён хотя бы один тип пуша; переключение пишет все пять.
    const isPushMasterOn = PUSH_TYPES.some((type) => isOn(pushCode(type)));
    const togglePushMaster = () => {
        const newValue = isPushMasterOn ? 'false' : 'true';
        PUSH_TYPES.forEach((type) => saveSetting(pushCode(type), newValue));
    };

    // Текущее время напоминания (строка минут). Если значения нет в списке — показываем как есть.
    const upcomingAdvance = String(userSettings?.upcomingInAdvanceTime ?? UPCOMING_ADVANCE_DEFAULT);
    const upcomingMinutes = UPCOMING_ADVANCE_OPTIONS.includes(Number(upcomingAdvance))
        ? UPCOMING_ADVANCE_OPTIONS
        : [...UPCOMING_ADVANCE_OPTIONS, Number(upcomingAdvance)].sort((a, b) => a - b);
    const upcomingOptions = upcomingMinutes.map((minutes) => ({
        value: String(minutes),
        label: txt('clientSettingsView.minutesBefore').replace('{n}', minutes),
    }));

    return (
        <div style={{flex: 1, minHeight: 10}}>
            {/* --- PUSH SECTION (мастер-свитч + 5 типов) --- */}
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <h2 style={{margin: 0}}>
                    {txt('clientSettingsView.pushNotifications')}
                </h2>
                <Switch checked={isPushMasterOn} onChange={togglePushMaster}/>
            </div>
            <List
                itemLayout="horizontal"
                dataSource={PUSH_TYPES}
                renderItem={(type) => {
                    const code = pushCode(type);
                    return (
                        <List.Item style={{paddingLeft: '1rem'}}>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
                                <span>{txt(`clientSettingsView.notificationsImportanceType.${type}`)}</span>
                                <Switch
                                    checked={isOn(code)}
                                    onChange={() => toggleSetting(code)}
                                />
                            </div>
                        </List.Item>
                    );
                }}
            />


            <Divider variant={'dashed'} style={{borderWidth: 3}}/>


            {/* --- Время напоминания об ожидаемой записи --- */}
            <div style={{paddingLeft: '1rem'}}>
                <h3 style={{marginTop: 0, marginBottom: 8}}>
                    {txt('clientSettingsView.upcomingReminder')}
                </h3>
                <Select
                    style={{minWidth: 180}}
                    value={upcomingAdvance}
                    options={upcomingOptions}
                    onChange={(value) => saveSetting('upcomingInAdvanceTime', value)}
                />
            </div>


            <Divider variant={'dashed'} style={{borderWidth: 3}}/>


            {/* --- Резервная отправка по email при недоставке пуша --- */}
            <div style={{paddingLeft: '1rem'}}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <span>{txt('clientSettingsView.emailFallback')}</span>
                    <Switch
                        style={{marginLeft: 12}}
                        checked={isOn('emailFallbackOnPushFailure')}
                        onChange={() => toggleSetting('emailFallbackOnPushFailure')}
                    />
                </div>
                <div style={{opacity: 0.65, fontSize: 12, marginTop: 4, maxWidth: 360}}>
                    {txt('clientSettingsView.emailFallbackHelp')}
                </div>
            </div>
        </div>
    );
}
